import {AppShell} from '@mantine/core';
import Header from "./components/Header"
import Footer from "./components/Footer"
import RouterSwitcher from "./components/RouterSwitcher";
import {ConfigProvider} from "./ConfigContext";

export function App() {
    return (
        <ConfigProvider>
            <AppShell header={{height: 70}} padding="md">
                <Header/>
                <AppShell.Main>
                    <RouterSwitcher/>
                    <Footer/>
                </AppShell.Main>
            </AppShell>
        </ConfigProvider>
    );
}

export default App;
